import {useEffect} from 'react';

/**
 * detect click outside component (hooks version)
 */
export default function useDetectOutsideClick(ref, callback, deps = []) {
  useEffect(() => {
    // Callback if clicked on outside of wrapper element.
    function handleClickOutside(event) {
      if (ref?.current && !ref?.current?.contains(event.target)) {
        callback(event);
      }
    }

    // Bind the event listener.
    setTimeout(() => {
      window.addEventListener('mousedown', handleClickOutside);
    }, 60);
    return () => {
      // Unbind the event listener on clean up.
      window.removeEventListener('mousedown', handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, ...deps]);
}
